/**
 * Derives 1–2 letter initials from a login string. Splits the local part of an
 * email on `.`, `_`, `-`, or whitespace; falls back to the first two chars
 * when no separators are present, or `?` for an empty input.
 */
export const computeInitials = (login: string): string => {
	if (!login) return "?";
	const local = login.split("@")[0] ?? login;
	const parts = local.split(/[._\-\s]+/).filter(Boolean);
	if (parts.length >= 2) {
		const a = parts[0]?.[0] ?? "";
		const b = parts[1]?.[0] ?? "";
		return `${a}${b}`.toUpperCase();
	}
	return local.slice(0, 2).toUpperCase();
};
